// Subtask draft schemas (docs/plans/2026-10-03-subtaken.md §5, §8). Own
// file so run-tools/catalog.ts can use them without importing the whole
// validators barrel.

import { z } from 'zod'

import { MAX_SUBTASKS_PER_CALL, SUBTASK_KEY_PATTERN } from '../types/subtasks.js'

export const SubtaskKeySchema = z
  .string()
  .regex(SUBTASK_KEY_PATTERN, 'Use 1-40 lowercase letters, digits, "-" or "_", starting with a letter or digit')

/** Same rule as `WorkflowKeySchema` (validators/index.ts), repeated to keep this file free of that barrel. */
const SubtaskWorkflowKeySchema = z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9_-]*$/, 'Use lowercase letters, digits, "-" or "_"')

/** `SubtaskDraftInput` (types/subtasks.ts). */
export const SubtaskDraftInputSchema = z.object({
  key: SubtaskKeySchema,
  title: z.string().trim().min(1).max(200),
  instructions: z.string().trim().min(1).max(20000),
  acceptanceCriteria: z.array(z.string().trim().min(1).max(1000)).max(30).optional(),
  workflow: SubtaskWorkflowKeySchema.nullable().optional(),
  dependsOn: z.array(SubtaskKeySchema).max(MAX_SUBTASKS_PER_CALL * 3).optional(),
})

/** POST /tasks/:id/subtasks body: one draft. */
export const CreateSubtaskRequestSchema = SubtaskDraftInputSchema
